module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-05-4903b4b82a13112078de7cfc3862528b.jpg";